import { Injectable } from '@angular/core';
import { z } from 'zod';
import { MessageLocalDataSourceService } from 'src/app/module/chat/data/repository/message/message-local-data-source.service'
import { MessageSocketRepositoryService } from 'src/app/module/chat/data/repository/message/message-live-signalr-data-source.service'
import { SessionStore } from 'src/app/store/session.service';
import { IMessageLocalRepository } from '../../repository/message/message-local-repository';
import { IMessageSocketRepository } from '../../repository/message/message-socket-repository';
import { v4 as uuidv4 } from 'uuid';

const MessageMarkAllMessageAsReadByRoomIdInputSchema = z.object({
  roomId: z.string(),
})

export type MessageMarkAllMessageAsReadByRoomIdInputSchema = z.infer<typeof MessageMarkAllMessageAsReadByRoomIdInputSchema>


/**
 * @description avoid using it, avoid duplicate query. do it on the UI layer as the component load the message.
 */
@Injectable({
  providedIn: 'root'
})
export class MessageMarkAllMessageAsReadByRoomIdService {

  constructor(
    private MessageLocalDataSourceService: IMessageLocalRepository,
    private MessageSocketRepositoryService: IMessageSocketRepository
  ) { }


  async execute(input: MessageMarkAllMessageAsReadByRoomIdInputSchema) {
    const messages = await this.MessageLocalDataSourceService.find({roomId:input.roomId})

    if(messages.isOk()) {
      for(const message of messages.value) {
        this.MessageSocketRepositoryService.sendReadAt({
          memberId: SessionStore.user.UserId,
          messageId: message.id,
          roomId: input.roomId,
          requestId: uuidv4()
        });
      }
    }

  }
}
